import Faucet from "./faucet.svg";
import GarbageDisposal from "./garbage-disposal.svg";
import OtherPlumbing from "./other-plumbing.svg";
import SewerBackup from "./sewer-backup.svg";
import Sink from "./sink.svg";
import Toilet from "./toilet.svg";
import WaterHeater from "./water-heater.svg";
import WaterPressure from "./water-pressure.svg";

const icons = {
  faucet: Faucet,
  "garbage-disposal": GarbageDisposal,
  "other-plumbing": OtherPlumbing,
  "sewer-backup": SewerBackup,
  sink: Sink,
  toilet: Toilet,
  "water-heater": WaterHeater,
  "water-pressure": WaterPressure,
};

export default icons;
